export const SUBMIT_MENTOR_ONBOARD_FORM_BEGIN =
  "SUBMIT_MENTOR_ONBOARD_FORM_BEGIN";
export const SUBMIT_MENTOR_ONBOARD_FORM_SUCCESS =
  "SUBMIT_MENTOR_ONBOARD_FORM_SUCCESS";
export const SUBMIT_MENTOR_ONBOARD_FORM_FAILURE =
  "SUBMIT_MENTOR_ONBOARD_FORM_FAILURE";
export const RESET_SUBMIT_MENTOR_ONBOARD_FORM =
  "RESET_SUBMIT_MENTOR_ONBOARD_FORM";
